<template>
<div>
      <div class="item empty"  :class="[emptyIndex==index?'activeMe':'']"  :style="{'animation-name':(index==emptyIndex?'upMove':'downMove')}" @mouseover="tapMouseOverE(index)" @mouseleave="tapMouseLeaveE(index)">
          <img src="../assets/images/zanwukecheng.png" />
     </div>
</div>
</template>
<script>
export default {
     props:{
        index:'',
        item:''
      },
  data() {     
    return {       
        emptyIndex:'-1'
    }
  },
  methods: {    

    
     tapMouseOverE(index){
       this.emptyIndex = index
    },
     tapMouseLeaveE(index){
       this.emptyIndex = '-1'
    },  
  }
}
</script>


// WEBPACK FOOTER //
// src/components/EmptyItem.vue